export default __webpack_public_path__ + "static/media/04 3D (2-1).3102bedd.jpg";